<template>
    <div class="maincontent">
      <Header :title="bankId != undefined && bankId != '' && bankId != null ? '编辑银行卡' : '添加银行卡'" :show="true" />
      <van-form @submit="onSave" label-width="70" validate-first ref="bankForm">
        <div class="main">
          <van-cell-group>
            <van-field
              v-model="bankName"
              label="银行名称"
              placeholder="点击选择银行"
              ref="bankName"
              clearable
              @click="showBankPicker = true"
            >
              <van-popup v-model="showBankPicker" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="bankColumns"
                  @confirm="bankOnConfirm"
                  @cancel="showBankPicker = false"
                />
              </van-popup>
            </van-field>
            <van-field
              v-model="bankAccount"
              label="银行卡号"
              placeholder="银行卡号"
              ref="bankAccount"
            />
            <van-field v-model="accountHolder" label="持卡人" placeholder="持卡人" ref="accountHolder"/>
          </van-cell-group>
        </div>
        <div style="margin-top:15px;">
          <van-button
            block
            type="info"
            color="var(--depYelColor)"
            native-type="submit"
          >{{(bankId != undefined && bankId != '' && bankId != null)?'保存':'提交'}}</van-button>
        </div>
      </van-form>
    </div>
  </template>
  <script>
  import {  addUpdateBank } from "api/submit";
  /*global $ */
  export default {
    components: {},
    data() {
      return {
        bankId: "",
        mlength: 22,
        bankName: "",
        bankAccount: "",
        accountHolder: "",
        show: false,
        showBankPicker: false,
        bankColumns: [
          "中国银行",
          "农业银行",
          "工商银行",
          "建设银行",
          "光大银行",
          "广发银行",
          "民生银行",
          "招商银行",
          "中信银行",
          "平安银行",
          "邮政储蓄银行",
          "交通银行",
          "浦发银行",
          "兴业银行",
          "广州银行",
          "东莞银行",
          "创兴银行",
          "花旗银行",
          "渤海银行",
          "浙商银行",
          "星展银行",
          "南粤银行",
          "国民银行",
          "恒生银行",
          "恒丰银行",
          "徽商银行",
          "汇丰银行",
          "华商银行",
          "华夏银行",
          "杭州银行",
          "江西银行",
          "九江银行",
          "江苏银行",
          "韩亚银行",
          "宁波银行",
          "上海银行",
          "友利银行",
          "渣打银行",
          "美国银行",
          "北京银行",
          "长沙银行",
          "东亚银行",
          "澳门国际银行",
          "国家开发银行",
          "珠海华润银行",
          "富邦华一银行",
          "广东华兴银行",
          "广东新兴农商",
          "华南商业银行",
          "泰国开泰银行",
          "韩国产业银行",
          "其它民营银行",
          "上海商业银行",
          "新韩银行中国",
          "法国兴业银行",
          "招商永隆银行",
          "信托商业银行",
          "厦门国际银行",
          "东莞农商银行",
          "广州农商银行",
          "惠州农商银行",
          "深圳农商银行",
          "珠海农商银行",
          "中山农商银行",
        ]
      };
    },
    mounted() {
        let bankId = this.$route.query.bankId
        this.bankName = this.$route.query.bankName
        this.bankAccount = this.$route.query.bankAccount
        this.accountHolder = this.$route.query.accountHolder
        if (bankId != undefined && bankId != '' && bankId != null) {
          this.bankId = bankId;
          this.getBankInfo();
        } else {
          this.$store.commit("setPageLoading", false);
        }
    },
    methods: {
      countLength(e) {
        if (e.keyCode != 8) {
          if (this.bankAccount != "") {
            this.bankAccount = this.bankAccount.replace(/(\d{4})(?=\d)/g, "$1  ");
          }
        }
      },
      bankOnConfirm(value) {
        this.bankName = value;
        this.showBankPicker = false;
      },
      onSave() {
        if (this.bankName != null && this.bankName != "") {
        } else {
          this.$error("请选择银行")
          this.$refs.bankName.focus()
        }
        if (this.bankAccount != null && this.bankAccount != "") {
        } else {
          this.$error("请输入银行卡号")
          this.$refs.bankAccount.focus()
        }
        if (this.accountHolder != null && this.accountHolder != "") {
          if (!this.$regSymbol(this.accountHolder)) {
            this.$error("持卡人姓名仅支持中文");
            this.$refs.accountHolder.focus();
            return;
          }
          if (this.accountHolder.length <= 1) {
            this.$error("请输入正确的持卡人");
            this.$refs.accountHolder.focus();
            return;
          }
        } else {
          this.$error("请输入持卡人");
          this.$refs.accountHolder.focus();
          return;
        }
        this.addUpdateBank()
      },
      addUpdateBank() {
        addUpdateBank(this.bankId, this.bankName, this.bankAccount, this.accountHolder).then((res) => {
          if (res.status === 200) {
            this.$successSync(res.message, () => {
              this.$back(-1);
            });
          } else {
            this.$error(res.message);
          }
        })
      },
      postAdd() {
        
        let carvalue;
        let carvalueconfim;
        if (this.cardNumber != "" && this.cardNumber != null) {
          carvalue = this.cardNumber.replace(new RegExp(/( )/g), "");         
          if (this.classId == 1) {
            let str = carvalue.substring(0, 6);
            if (!"100011".includes(str)) {
              this.$error("请输入100011开头非副卡号");
              
              return;
            }
          } else {
            let str = carvalue.substring(0, 4);
            if ("9030900090889020".includes(str)) {
              if ("9088".includes(str)) {
                this.mlength = 22;
              }
            } else {
              this.$error("请输入9030、9000、9088、9020开头、非副卡号");
              this.$refs.cardno.focus();
              return;
            }
          }
        } else {
          this.$error("请输入" + this.remark);
          this.$refs.cardno.focus();
          return;
        }
        if (this.classId == 1) {
          if (carvalue.length != 19) {
            this.$error("请输入19位加油卡号");
            this.$refs.cardno.focus();
            return;
          }
        } else {
          if (carvalue.length != 16) {
            this.$error("请输入16位加油卡号");
            this.$refs.cardno.focus();
            return;
          }
        }
  
        if (this.confirm != "" && this.confirm != null) {
          carvalueconfim = this.confirm.replace(new RegExp(/( )/g), "");
          if (carvalueconfim != carvalue) {
            this.$error("两次卡号输入不一致");
            return;
          }
        } else {
          this.$error("请输入确认卡号");
          this.$refs.confirmno.focus();
          return;
        }
  
        if (this.userName != null && this.userName != "") {
          if (!this.$regSymbol(this.userName)) {
            this.$error("持卡人姓名仅支持中文");
            this.$refs.owner.focus();
            return;
          }
          if (this.userName.length <= 1) {
            this.$error("请输入正确的持卡人");
            this.$refs.owner.focus();
            return;
          }
        } else {
          this.$error("请输入持卡人");
          this.$refs.owner.focus();
          return;
        }
        if (!this.$regPhone(this.phone)) {
          this.$error("请输入正确的手机号码");
          this.$refs.phone.focus();
          return;
        }
  
        let that = this;
        that.$dialog
          .confirm({
            title: "提示",
            message:
              "<span style='color: red;font-size: 20px;font-weight:900;'>卡号：" +
              carvalue.replace(/(.{4})/g, "$1 ") +
              "</span><p>请核对卡号信息是否正确，若核对无误，再确认添加!</p>",
            confirmButtonColor: "var(--depYelColor)",
          })
          .then(() => {
            // on confirm
            that.addUpdateOilCard("",this.classId,carvalue, this.userName, this.phone);
          })
          .catch(() => {
            // on cancel
          });
      },
  
      onClick(name) {
        this.cardNumber = "";
        this.confirm = "";
        if (name == 1) {
          this.mlength = 27;
          this.classId = 1;
          this.remark = "100011开头非副卡";
        } else {
          this.mlength = 22;
          this.classId = 2;
          this.remark = "9030、9000、9088、9020开头、非副卡";
        }
      },
      addUpdateOilCard(id,type,carvalue,userName,phone) {
        addUpdateOilCard(id,carvalue,type-1,userName,phone).then((res) => {
          if (res.status == 200) {
            this.$successSync("添加成功", () => {
              this.$back(-1);
            });
          } else {
            this.$error(res.message);
          }
        });
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .maincontent {
    .van-tabs {
      // padding-top: 14px !important;
      background-color: #fff;
      border-radius: 5px;
      // box-shadow: #ccc 0 0px 1px;
      .van-tabs__content {
        button {
          width: 92%;
          margin: 14px;
        }
        input {
          width: 85px;
        }
        .van-cell {
          line-height: 40px;
        }
      }
    }
  }
  </style>